export const POS_RECO_MAPPING_MOPS = [
	{
		id: "PHONEPE",
		name: "Phone Pe",
		headerMode: "first_row",
		columns: [
			{ internal_column: "TransactionDate", file_header: "TransactionDate", is_required: true, reason: "Collection date" },
			{ internal_column: "Amount", file_header: "Amount", is_required: true, reason: "Collection amount" },
			{ internal_column: "StoreId", file_header: "StoreId", is_required: true, reason: "Store / merchant join" },
			{ internal_column: "MerchantReferenceId", file_header: "MerchantReferenceId", is_required: true, reason: "Dedupe key" },
			{ internal_column: "PhonePeReferenceId", file_header: "PhonePeReferenceId", is_required: true, reason: "Dedupe key" },
			{ internal_column: "SettlementDate", file_header: "SettlementDate", is_required: true, reason: "Dedupe / settlement date" },
			{ internal_column: "CreationDate", file_header: "CreationDate", is_required: false, reason: "Optional date column" },
		],
	},
	{
		id: "BANK_STATEMENT",
		name: "Bank Statement",
		headerMode: "row_index",
		headerRow: 20,
		columns: [
			{ internal_column: "Date", file_header: "Date", is_required: true, reason: "Transaction date" },
			{ internal_column: "Narration", file_header: "Narration", is_required: true, reason: "Refund / chargeback classification" },
			{ internal_column: "Withdrawal_Amt", file_header: "Withdrawal Amt.", is_required: true, reason: "Collection amount" },
			{ internal_column: "Chq_Ref_No", file_header: "Chq./Ref.No.", is_required: true, reason: "UTR / refund reference" },
			{ internal_column: "Deposit_Amt", file_header: "Deposit Amt.", is_required: false, reason: "Optional deposit amount" },
		],
	},
	{
		id: "AMEX",
		name: "Amex",
		headerMode: "match_mapped",
		columns: [
			{ internal_column: "Settlement_date", file_header: "Settlement date", is_required: true, reason: "Dedupe date" },
			{ internal_column: "Submission_date", file_header: "Submission date", is_required: true, reason: "Collection date" },
			{ internal_column: "SOC_invoice_number", file_header: "SOC invoice number", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Submitting_Merchant_ID", file_header: "Submitting Merchant ID", is_required: true, reason: "Store / merchant join" },
			{ internal_column: "Submission_amount", file_header: "Submission amount", is_required: true, reason: "Collection amount" },
			{ internal_column: "Settlement_number", file_header: "Settlement number", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Merchant_Fees", file_header: "Merchant Fees", is_required: false },
			{ internal_column: "Fees_and_incentives", file_header: "Fees and incentives", is_required: false },
			{ internal_column: "Total_charges", file_header: "Total charges", is_required: false },
			{ internal_column: "Credits", file_header: "Credits", is_required: false },
			{ internal_column: "Transaction_count", file_header: "Transaction count", is_required: false },
			{ internal_column: "Submitting_Nickname", file_header: "Submitting Nickname", is_required: false },
			{ internal_column: "Tax_amount", file_header: "Tax amount", is_required: false },
			{ internal_column: "CGST", file_header: "CGST", is_required: false },
			{ internal_column: "SGST", file_header: "SGST", is_required: false },
			{ internal_column: "Settlement_amount", file_header: "Settlement amount", is_required: false },
			{ internal_column: "Submitting_Business_Name", file_header: "Submitting Business Name", is_required: false },
			{ internal_column: "Amount_of_adjustment_to_summary", file_header: "Amount of adjustment to summary", is_required: false },
			{ internal_column: "Description", file_header: "Description", is_required: false },
			{ internal_column: "Payee_Merchant_ID", file_header: "Payee Merchant ID", is_required: false },
			{ internal_column: "Payee_Nickname", file_header: "Payee Nickname", is_required: false },
			{ internal_column: "Transaction_date", file_header: "Transaction date", is_required: false },
			{ internal_column: "Activity_Type", file_header: "Activity Type", is_required: false },
		],
	},
	{
		id: "CARD",
		name: "Card",
		headerMode: "first_row",
		columns: [
			{ internal_column: "CHG_DATE", file_header: "CHG_DATE", is_required: true, reason: "Collection date" },
			{ internal_column: "PYMT_CHGAMNT", file_header: "PYMT_CHGAMNT", is_required: true, reason: "Collection amount" },
			{ internal_column: "TERMINAL_NO", file_header: "TERMINAL_NO", is_required: true, reason: "TID / store join" },
			{ internal_column: "TRANSACTION_ID", file_header: "TRANSACTION_ID", is_required: true, reason: "Dedupe key" },
			{ internal_column: "ARN", file_header: "ARN", is_required: true, reason: "Dedupe key" },
			{ internal_column: "PROCESS_DATE", file_header: "PROCESS_DATE", is_required: true, reason: "Dedupe / process date" },
		],
	},
	{
		id: "UPI",
		name: "UPI",
		headerMode: "after_marker",
		marker: "UPI TRANSACTIONS",
		columns: [
			{ internal_column: "Transaction_Req_Date", file_header: "Transaction_Req_Date", is_required: true, reason: "Collection date" },
			{ internal_column: "Transaction_Amount", file_header: "Transaction_Amount", is_required: true, reason: "Collection amount" },
			{ internal_column: "EXTERNAL_MID", file_header: "EXTERNAL_MID", is_required: true, reason: "MID / store join" },
			{ internal_column: "CRDR", file_header: "CRDR", is_required: true, reason: "Credit / debit filter" },
			{ internal_column: "Txn_ref_no_RRN", file_header: "Txn_ref_no_RRN", is_required: true, reason: "RRN / refund join" },
			{ internal_column: "EXTERNAL_TID", file_header: "EXTERNAL_TID", is_required: true, reason: "TID / Pay By Link exclusion" },
			{ internal_column: "UPI_Merchant_ID", file_header: "UPI_Merchant_ID", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Merchant_Name", file_header: "Merchant_Name", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Merchant_VPA", file_header: "Merchant_VPA", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Payer_VPA", file_header: "Payer_VPA", is_required: true, reason: "Dedupe key" },
			{ internal_column: "UPI_Trxn_ID", file_header: "UPI_Trxn_ID", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Order_ID", file_header: "Order_ID", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Settlement_Date", file_header: "Settlement_Date", is_required: false, reason: "Optional settlement date" },
		],
	},
	{
		id: "MAGICPIN",
		name: "Magicpin",
		headerMode: "first_row",
		sheetName: "Order Level",
		columns: [
			{ internal_column: "Transaction_Time", file_header: "Transaction Time", is_required: true, reason: "Collection date" },
			{ internal_column: "Gross_Order_Value", file_header: "Gross Order Value", is_required: true, reason: "Collection amount" },
			{ internal_column: "Merchant_Id", file_header: "Merchant Id", is_required: true, reason: "Store / merchant join" },
			{ internal_column: "Transaction_Id", file_header: "Transaction Id", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Voucher_Code", file_header: "Voucher Code", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Utr", file_header: "Utr", is_required: true, reason: "Dedupe key" },
			{ internal_column: "closed_date", file_header: "closed date", is_required: false, reason: "Optional closed date" },
		],
	},
	{
		id: "ZOMATO",
		name: "Zomato",
		headerMode: "row_index",
		sheetName: "Transactions summary",
		headerRow: 6,
		columns: [
			{ internal_column: "Date_and_time", file_header: "Date and time", is_required: true, reason: "Collection date" },
			{ internal_column: "Bill_Amount", file_header: "Bill Amount", is_required: true, reason: "Collection amount" },
			{ internal_column: "Store_ID", file_header: "Store ID", is_required: true, reason: "Store join" },
			{ internal_column: "Transaction_ID", file_header: "Transaction ID", is_required: true, reason: "Dedupe key" },
			{ internal_column: "UTR_Number_Reference_ID", file_header: "UTR Number / Reference ID", is_required: true, reason: "Dedupe key" },
			{ internal_column: "Franchise_ID", file_header: "Franchise ID", is_required: true, reason: "Dedupe key" },
		],
	},
];

export const getDefaultMopSchema = (mopId) => POS_RECO_MAPPING_MOPS.find((mop) => mop.id === mopId) || POS_RECO_MAPPING_MOPS[0];

export const normalizeHeader = (value = "") =>
	String(value || "")
		.trim()
		.toLowerCase()
		.replace(/[^\w]+/g, "_")
		.replace(/_+/g, "_")
		.replace(/^_+|_+$/g, "");

export const findMatchingHeader = (fileHeaders = [], mappedHeader = "") => {
	if (!mappedHeader) return null;
	const exact = fileHeaders.find((header) => header === mappedHeader);
	if (exact) return exact;
	const lower = mappedHeader.toLowerCase();
	const caseMatch = fileHeaders.find((header) => String(header).trim().toLowerCase() === lower);
	if (caseMatch) return caseMatch;
	const normalized = normalizeHeader(mappedHeader);
	return fileHeaders.find((header) => normalizeHeader(header) === normalized) || null;
};

export const validateMappingAgainstFile = (columns = [], fileHeaders = []) => {
	const errors = [];
	const warnings = [];

	if (!fileHeaders.length) {
		return {
			ok: false,
			errors: ["Could not read file headers. Check the file format for this MOP."],
			warnings,
			missing: [],
		};
	}

	const missing = [];
	(columns || []).forEach((column) => {
		if (!column?.is_required) return;
		if (!column.file_header) {
			missing.push(column.internal_column);
			return;
		}
		if (!findMatchingHeader(fileHeaders, column.file_header)) {
			missing.push(`${column.internal_column} ← "${column.file_header}"`);
		}
	});

	if (missing.length) {
		errors.push(
			`File headers do not match the saved mapping: ${missing.join(", ")}. Update Column Mapping.`,
		);
	}

	return { ok: errors.length === 0, errors, warnings, missing };
};
